const basePath = `${process.env.REACT_APP_BACKEND_HOST}/api/`;
const thorApis = {
  getType: `${basePath}getType`,
};
export default { ...thorApis };



// WEBPACK FOOTER //
// ./src/api/endPoints/overwatchEndPoint.js